import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=5ff31c92&scoped=true&"
import script from "./Appointment.vue?vue&type=script&lang=js&"
export * from "./Appointment.vue?vue&type=script&lang=js&"
import style0 from "./Appointment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Appointment.vue?vue&type=style&index=1&id=5ff31c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff31c92",
  null
  
)

export default component.exports